import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { RemovePositionDialog } from "@/routes/_layout/settings/_panel/-components/remove-position-dialog"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId/positions/$positionId/remove",
)({
  component: RemovePosition,
})

function RemovePosition(): React.ReactElement {
  const { departmentId, positionId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/settings/workspace/departments/$departmentId",
      params: { departmentId },
      search: true,
    })

  return (
    <RemovePositionDialog
      owner={{ department_id: departmentId }}
      positionId={positionId}
      onRemoved={(removed) => {
        showToast("Removed", `${removed.name} removed.`, "success")
        close()
      }}
      onClose={close}
    />
  )
}
